import React, { useEffect, useState } from "react";
import { useField } from "formik";
import { MultiSelect } from "primereact/multiselect";
import { commonStyles } from "./types";
import { authService } from "../../service/AuthService";
import { Chapter } from "../../interfaces/transporters.interface";
import api from "../../api";

interface ChapterDetails extends Chapter {
  title: string;
  description?: string;
}

export const ChaptersSection: React.FC<{ transporterId: string }> = () => {
  const [field, meta, helpers] = useField("selectedChapters");
  const transporter = authService.getUser();
  const [chapters, setChapters] = useState<ChapterDetails[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchChapterDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.get(`/chapters/transporter/${transporter?._id}`);
        const transporterData = response.data.data;
        if (transporterData && transporterData.chapters) {
          setChapters(transporterData.chapters);
        }
      } catch (err) {
        console.error("Error fetching chapter details:", err);
        setError("Erreur lors du chargement des chapitres");
      } finally {
        setLoading(false);
      }
    };

    if (transporter?._id) {
      fetchChapterDetails();
    }
  }, [transporter?._id]);

  const handleChapterChange = (e: { value: string[] }) => {
    helpers.setValue(e.value);
  };

  if (loading) {
    return <div>Chargement des chapitres...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <div className="space-y-4">
      <label className={commonStyles.labelClassName}>
        Chapitres autorisés
      </label>
      <div>
        {chapters.length === 0 ? (
          <div className="text-gray-500">Aucun chapitre disponible</div>
        ) : (
          <>
            <MultiSelect
              value={field.value}
              options={chapters}
              onChange={handleChapterChange}
              optionLabel="title"
              optionValue="_id"
              placeholder="Sélectionnez les chapitres"
              display="chip"
              className={`w-full font-sans ${meta.touched && meta.error ? 'p-invalid' : ''}`}
              filter
              filterPlaceholder="Rechercher un chapitre"
              emptyFilterMessage="Aucun chapitre trouvé"
              optionGroupChildren="items"
            />
            {meta.touched && meta.error && (
              <small className={commonStyles.errorClassName}>
                {meta.error}
              </small>
            )}
          </>
        )}
      </div>
    </div>
  );
};
